/**
 * DescriptionInfoContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled description info container.
 */
const DescriptionInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${14 * Screen.widthRatio}px;
`;

export default DescriptionInfoContainer;
